import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import { errorMsg, refreshToken } from 'utils';
import axios from 'axios';

export const WEB_PAGES_FETCH = createAction('WEB_PAGES_FETCH');
export const WEB_PAGES_FETCH_DATA_SUCCESS = createAction('WEB_PAGES_FETCH_DATA_SUCCESS');
export const WEB_PAGES_FETCH_DATA_FAIL = createAction('WEB_PAGES_FETCH_DATA_FAIL');

export const WEB_PAGES_DELETE_INIT = createAction('WEB_PAGES_DELETE_INIT');
export const WEB_PAGES_DELETE_SUCCESS = createAction('WEB_PAGES_DELETE_SUCCESS');
export const WEB_PAGES_DELETE_FAIL = createAction('WEB_PAGES_DELETE_FAIL');

export const WEB_PAGES_CREATE_INIT = createAction('WEB_PAGES_CREATE_INIT');
export const WEB_PAGES_CREATE_SUCCESS = createAction('WEB_PAGES_CREATE_SUCCESS');
export const WEB_PAGES_CREATE_FAIL = createAction('WEB_PAGES_CREATE_FAIL');

export const WEB_PAGES_MODIFY_INIT = createAction('WEB_PAGES_MODIFY_INIT');
export const WEB_PAGES_MODIFY_SUCCESS = createAction('WEB_PAGES_MODIFY_SUCCESS');
export const WEB_PAGES_MODIFY_FAIL = createAction('WEB_PAGES_MODIFY_FAIL');

export const WEB_PAGES_CLEAN_UP = createAction('WEB_PAGES_CLEAN_UP');
export const WEB_PAGES_CLEAR_DATA_LOGOUT = createAction('WEB_PAGES_CLEAR_DATA_LOGOUT');

export const fetchWebPages = ({ siteId }) => async (dispatch) => {
  dispatch(WEB_PAGES_FETCH());
  try {
    const token = await refreshToken();
    const res = await axios.get(`${url}/webPages/list/${siteId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return dispatch(WEB_PAGES_FETCH_DATA_SUCCESS({ list: res.data.data || [] }));
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_PAGES_FETCH_DATA_FAIL({ error }));
  }
};

export const addWebPages = (data, callback) => async (dispatch) => {
  dispatch(WEB_PAGES_CREATE_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.post(`${url}/webPages/create`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Page created successfully');
    dispatch(WEB_PAGES_CREATE_SUCCESS({ page: res.data.data }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_PAGES_CREATE_FAIL({ error }));
  }
};

export const updateWebPages = (id, data, callback) => async (dispatch) => {
  dispatch(WEB_PAGES_MODIFY_INIT());
  try {
    const token = await refreshToken();
    const res = await axios.put(`${url}/webPages/update/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Page updated successfully');
    dispatch(WEB_PAGES_MODIFY_SUCCESS({ page: res.data.data, id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_PAGES_MODIFY_FAIL({ error }));
  }
};

export const deleteWebPages = (id, callback) => async (dispatch) => {
  dispatch(WEB_PAGES_DELETE_INIT());
  try {
    const token = await refreshToken();
    await axios.delete(`${url}/webPages/delete/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    toastr.success('', 'Page deleted successfully');
    dispatch(WEB_PAGES_DELETE_SUCCESS({ id }));
    if (callback) callback();
  } catch (error) {
    toastr.error('', `${errorMsg(dispatch, error)}`);
    return dispatch(WEB_PAGES_DELETE_FAIL({ error }));
  }
};
